var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_4488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_4488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6923 17.6152C14.0499 17.6152 13.5048 17.3912 13.0568 16.9432C12.6088 16.4951 12.3848 15.9498 12.3848 15.3075C12.3848 14.6652 12.6088 14.12 13.0568 13.672C13.5048 13.224 14.0499 13 14.6923 13C15.3346 13 15.8798 13.224 16.328 13.672C16.776 14.12 17 14.6652 17 15.3075C17 15.9498 16.776 16.4951 16.328 16.9432C15.8798 17.3912 15.3346 17.6152 14.6923 17.6152ZM5.30775 21.1152C4.80258 21.1152 4.375 20.9403 4.025 20.5903C3.675 20.2402 3.5 19.8127 3.5 19.3075V5.923C3.5 5.41783 3.675 4.99025 4.025 4.64025C4.375 4.29025 4.80258 4.11525 5.30775 4.11525H6.69225V2H8.23075V4.11525H15.8077V2H17.3077V4.11525H18.6923C19.1974 4.11525 19.625 4.29025 19.975 4.64025C20.325 4.99025 20.5 5.41783 20.5 5.923V19.3075C20.5 19.8127 20.325 20.2402 19.975 20.5903C19.625 20.9403 19.1974 21.1152 18.6923 21.1152H5.30775ZM5.30775 19.6152H18.6923C18.7692 19.6152 18.8398 19.5832 18.9038 19.519C18.9679 19.455 19 19.3845 19 19.3075V9.923H5V19.3075C5 19.3845 5.03208 19.455 5.09625 19.519C5.16025 19.5832 5.23075 19.6152 5.30775 19.6152ZM5 8.423H19V5.923C19 5.846 18.9679 5.7755 18.9038 5.7115C18.8398 5.64733 18.7692 5.61525 18.6923 5.61525H5.30775C5.23075 5.61525 5.16025 5.64733 5.09625 5.7115C5.03208 5.7755 5 5.846 5 5.923V8.423Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.65455c00456994cbf353761d5fb4c81f.svg";
export { ForwardRef as ReactComponent };